/* eslint-disable */

//ffs why we still need this?
var deferredPrompt;
window.addEventListener("beforeinstallprompt", (e) => {
  deferredPrompt = e;
});

// Import Vue
import Vue from "vue";

//initialize service worker
if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .getRegistrations()
    .then((registrations) => {
      var serviceWorker = registrations[0];
      Vue.prototype.SWEnable = true;
      if (serviceWorker) {
        //already register
        Vue.prototype.$PushManager = new Promise((resolve, rejects) => {
          if ("PushManager" in window) resolve(serviceWorker.pushManager);
          else rejects();
        });
      } else {
        Vue.prototype.$PushManager = new Promise((resolve, rejects) => {
          navigator.serviceWorker
            .register("./service-worker.js")
            .then(function(registration) {
              console.log("Service Worker Registered");
              if ("PushManager" in window) resolve(registration.pushManager);
              else rejects();
            })
            .catch((error) => {
              console.error(error);
              rejects();
            });
        });
      }
    })
    .catch((error) => {});
} else Vue.prototype.SWEnable = false;

import VeeValidate, { Validator } from "vee-validate";
// Import F7
import Framework7 from "framework7";

// Import F7 Vue Plugin
import Framework7Vue from "framework7-vue";

// Import F7 iOS Theme Styles
// import Framework7Theme from 'framework7/dist/css/framework7.ios.min.css'
// import Framework7ThemeColors from 'framework7/dist/css/framework7.ios.colors.min.css'
// OR for Material Theme:
import Framework7Theme from "framework7/dist/css/framework7.material.min.css";
import Framework7ThemeColors from "framework7/dist/css/framework7.material.colors.min.css";
//
import "framework7-icons/css/framework7-icons.css";
import "font-awesome/css/font-awesome.css";
import "nouislider/distribute/nouislider.min.css";
// Import App Custom Styles
import AppStyles from "./sass/main.scss";

// Import Routes
import Routes from "./routes.js";

// Import App Component
import App from "./components/app";
// import i18n from "./utils/i18n";
import VueTheMask from "vue-the-mask";
// import currencyFilter from "./utils/currency.filter";

Vue.use(VueTheMask);
Vue.use(Framework7Vue);
Vue.use(VeeValidate);
// Vue.use(i18n);
import Navbar from "./components/navbar.vue";
import AddToHomescreen from "./components/add-to-homescreen.vue";
import AddToHomescreenAdaptive from "./components/add-to-homescreen-adaptive.vue";

import moment from "moment";
import vueTelInput from "./components/tel-input.vue";
import VueAwesomeSwiper from "vue-awesome-swiper";
import AddToHomescreenButton from "./components/add-homescreen-button.vue";
import VueYoutube from "vue-youtube";
import PageHeader from "@components/page-header.vue";
import Notifications from "vue-notification";

import "nouislider/distribute/nouislider.min.css";

Vue.component("bc-navbar", Navbar);
Vue.component("add-to-homescreen", AddToHomescreen);
Vue.component("add-to-homescreen-adaptive", AddToHomescreenAdaptive);
Vue.component("add-homescreen-button", AddToHomescreenButton);
Vue.component("vue-tel-input", vueTelInput);
Vue.component("page-header", PageHeader);
Vue.use("vue-awasome-swiper", VueAwesomeSwiper);
Vue.use(VueYoutube);
Vue.use(Notifications);

Vue.filter("dateFormat", function(date, format) {
  return moment(date).format(format);
});

import store from "./store";
import f7Config from "./f7-config";
import { mapState } from "vuex";
import { PAGES } from "./shared/routes.constants";
import { CustomValidation } from "./shared/custom-validation";
import browserHelper from './helpers/browser.helper.js'
// Init App
new Vue({
  el: "#app",
  store,
  template: "<app/>",
  framework7: f7Config,
  // Register App Component
  components: {
    app: App,
  },
  created: function() {
    this.initPromise = store.dispatch("init");
    // this.afterAuthVerifiedActions();
    this.initCustomValidation();
  },
  computed: {
    ...mapState({
      isMobile: (state) => state.standalone.isMobile,
      homeSlides: (state) => state.common.homeImages,
      firstLoad: (state) => state.common.firstLoad,
      isDemoUser: (state) => state.editUserProfile.customerUser.isDemoUser,
    }),
  },
  methods: {
    afterAuthVerifiedActions() {
      let tokenId;
      let sharedItemId;
      this.$store.dispatch("standalone/mobileCheck");
      if (window.location.href.indexOf("#") >= 0) {
        window.location.href = window.location.href.replace("#!//", "");
        return;
      }

      if (this.$route) {
        tokenId = this.$route.params.tokenId;
        sharedItemId = this.$route.query.sharedItemId;
        if (sharedItemId) {
          this.$store.dispatch("login/setSharedItemId", sharedItemId);
        }

        if (tokenId) {
          this.authenticate(tokenId, sharedItemId);
          return;
        }

        var isAuthorized = this.$store.state.login.isAuthorized;
        isAuthorized ? this.afterAuth() : this.unauthorized();
      } else {
        var isAuthorized = this.$store.state.login.isAuthorized;
        if (isAuthorized) {
          this.afterAuth();
          this.$f7.mainView.router.load({ url: "home" });
        } else {
          this.unauthorized();
        }
      }

      // if (this.$route != undefined) {
      //   tokenId = this.$route.params.tokenId; //?
      //   sharedItemId = this.$route.query.sharedItemId;

      // }
      // if (
      //   this.$store.state.login.isAuthorized &&
      //   localStorage.accessId != undefined &&
      //   (localStorage.accessId == tokenId ||
      //     tokenId == undefined ||
      //     tokenId == "" ||
      //     tokenId.length < 32)
      // ) {
      //   this.afterAuth();
      // } else {
      //   if (tokenId) {
      //     this.$store
      //       .dispatch("login/auth", { tokenId, sharedItemId })
      //       .then((response) => {
      //         this.afterAuth();
      //       })
      //       .catch((e) => console.log(e));
      //   } else {
      //     this.$f7.mainView.router.load({ url: "home" });
      //   }
      // }
    },
    authenticate(tokenId, sharedItemId) {
      this.$store
        .dispatch("login/auth", { tokenId, sharedItemId })
        .then((response) => {
          this.afterAuth();
        })
        .catch((e) => {
          this.unauthorized();
        });
    },
    unauthorized() {
      // redirect to the unauthorized page
      // hack. without setTimeout the router does no redirects to the 401 page. need investigate
      setTimeout(
        () =>
          this.$f7.mainView.router.load({
            url: "401",
            force: true,
            reload: true,
          }),
        500
      );
    },
    initCustomValidation() {
      const dict = {
        custom: {
          referralName: {
            required: "This field is required",
            min: "This field must contain a minimum of 3 characters",
            fullName: "Please add first and last name",
          },
        },
      };
      Validator.localize("en", dict);
      Validator.extend("fullName", {
        getMessage: (field) => "Please add first and last name",
        validate: CustomValidation.fullName,
      });
      Validator.extend("phone", {
        getMessage: (field) => "Invalid phone number",
        validate: CustomValidation.phone,
      });
    },
    afterAuth() {
      if (this.$store.state.login.isAuthorized) {
        this.$store.dispatch(
          "standalone/checkBrowser",
          this.$store.state.login.isRegistered
        );
        this.$store.dispatch("editUserProfile/loadUserProfile");
        this.trackOpenApp();
        this.$store
          .dispatch("common/loadHomePageSettings")
          .then((res) => this.onSettingsLoaded(res)),
          this.$store.dispatch("recommendFriend/loadRecommendFriendHistory");
      } else {
        this.unauthorized();
      }
    },
    onSettingsLoaded({ isDealerDeleted, isSalesPersonDeleted }) {
      if (!isDealerDeleted && !isSalesPersonDeleted) {
        if (this.$route && this.$route.query.sharedItemId) {
          setTimeout(
            () => this.$f7.mainView.router.load({ url: "home", reload: true }),
            500
          ); // hack. redirect to prevent refresing page with the sharedItemId param)
        }
      } else if (isDealerDeleted) {
        this.$f7.mainView.router.load({
          url: "deleted/dealer",
          force: true,
          pushState: true,
        });
      } else {
        this.$store
          .dispatch("common/getDeletedInfo")
          .then((isReassigned) => this.onDealerInfoLoaded(isReassigned));
      }
    },
    onDealerInfoLoaded(isReassigned) {
      this.$nextTick(() => {
        isReassigned
          ? this.$f7.mainView.router.load({
              url: PAGES.Reassigned,
              force: true,
              //pushState: true,
              reload: true,
            })
          : this.$f7.mainView.router.load({
              url: PAGES.DeletedSalesperson,
              force: true,
              //pushState: true,
              reload: true,
            });
      });
    },
    trackOpenApp() {
      if(browserHelper.isFreshAppOpen()){
        this.$store.dispatch("common/setFirstOpenApp", true);
      }
    },
  },
  mounted: function() {
    console.log("mounted main");
    this.initPromise.then(
      //here we have: system data initialized, token checked, f7 working
      () => {
        this.afterAuthVerifiedActions();
      }
    );
  },
});



// WEBPACK FOOTER //
// ./scripts/src/main.js